<template>
  <div class="subscribe-course-section">
    <div
      v-if="isCheckout"
      class="subscribe-course-section-left"
      style="background-image: url('/img/request-a-course.png');"
    ></div>
    <div
      v-else
      class="subscribe-course-section-left"
      style="background-image: url('/img/subscribebg.png');"
    >
      <course-template :course-data="getSelectedCourse" />
    </div>
    <div class="subscribe-course-section-right">
      <h4 class="title">Select an option</h4>
      <div class="plan-tires" v-if="isCheckout">
        <div class="tier-wrapper selected" id="plan12">
          <div class="tier-check">
            <font-awesome-icon icon="check-circle" size="lg" />
          </div>
          <div class="tire-details">
            <div class="price">₹{{ totalPrice }}</div>
            <p class="heading">
              Total {{ getCart.length }}
              {{ getCart.length > 1 ? "Courses" : "Course" }}
            </p>
          </div>
        </div>
      </div>
      <div class="plan-tires" v-else>
        <div class="tier-wrapper selected" @click="toggleSelect" id="plan1">
          <div class="tier-check">
            <div class="circle" v-if="!availablePlans.plan1"></div>
            <font-awesome-icon
              icon="check-circle"
              size="lg"
              v-if="availablePlans.plan1"
            />
          </div>
          <div class="tire-details">
            <div class="price">₹{{ getSelectedCourse.price }}</div>
            <p class="heading">{{ getSelectedCourse.name }}</p>
            <div class="classifications">
              <span>{{ getSelectedCourse.total_videos }} Weeks</span>
              <span>{{ getSelectedCourse.total_videos }} Sessions</span>
            </div>
          </div>
        </div>
        <!--<div class="tier-wrapper alloffer" @click="toggleSelect" id="plan2">-->
        <!--<div class="tier-check">-->
        <!--<div class="circle" v-if="!availablePlans.plan2"></div>-->
        <!--<font-awesome-icon-->
        <!--icon="check-circle"-->
        <!--size="lg"-->
        <!--v-if="availablePlans.plan2"-->
        <!--/>-->
        <!--</div>-->
        <!--<div class="tire-details">-->
        <!--<div class="price">-->
        <!--<span class="crossed">₹8,500</span><span>₹5,500</span>-->
        <!--</div>-->
        <!--<p class="heading">Some application of Trigonometry</p>-->
        <!--<div class="classifications">-->
        <!--<span>10 Weeks</span>-->
        <!--<span>70 Sessions</span>-->
        <!--<span>7 Subjects</span>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
      </div>
      <v-select
        placeholder="Mode of payment"
        class="my-5"
        label="gateway_name"
        :options="paymentOptions"
        v-model="selectedOption"
        name="Payment Option"
      />
      <div
        class="invalid-feedback"
        style="display: block"
        id="teacher-location-live-feedback"
        v-if="!selectedOption && showOption"
      >
        <small>Choose a Payment Option</small>
      </div>
      <continue-payment-button
        :courses="courses"
        :total-price="totalPrice"
        :gateway="selectedOption"
        :isCheckout="isCheckout"
        @optionValidation="optionValidate"
      />
    </div>
  </div>
</template>

<script>
import CourseTemplate from "../components/Templates/CourseTemplate";
import { store } from "../store/store";
import { mapGetters, mapActions } from "vuex";
import ContinuePaymentButton from "../components/payment/ContinuePaymentButton";
import { subscriptionApi } from "../services/subscriptionApi";

export default {
  name: "course-subscription",
  components: {
    CourseTemplate,
    ContinuePaymentButton
  },
  computed: {
    ...mapGetters("courses", ["getSelectedCourse"]),
    ...mapGetters("user", [
      "isAuthenticated",
      "getUserDetails",
      "getUserRole",
      "getSubscribedCourses",
      "getSubscribedLiveCourses",
      "getTeacherCourses",
      "getTeacherLiveCourses"
    ]),
    ...mapGetters("cart", ["getCart"]),
    ...mapGetters("events", ["isCheckout"]),
    totalPrice() {
      let total = 0;
      if (this.isCheckout) {
        this.getCart.forEach(cartData => {
          total = total + parseInt(cartData.price);
        });
      } else {
        total = parseInt(this.getSelectedCourse.price);
      }
      return total;
    }
  },
  watch: {
    chosenPlan() {
      for (let [key, value] of Object.entries(this.availablePlans)) {
        if (key === this.chosenPlan) {
          this.availablePlans[key] = true;
        } else {
          this.availablePlans[key] = false;
        }
      }
    },
    isAuthenticated() {
      if (!this.isAuthenticated) {
        this.$router.push({
          path: "course_description",
          query: {
            courseId: this.getSelectedCourse.course_id,
            courseType: this.getSelectedCourse.isLiveCourse
              ? "liveCourse"
              : "course"
          }
        });
      }
    }
  },
  data() {
    return {
      chosenPlan: "",
      availablePlans: {
        plan1: true,
        plan2: false
      },
      paymentOptions: [],
      selectedOption: null,
      showOption: false,
      orderId: "",
      showRazorPay: false,
      isSubscribed: false,
      courses: [],
      type: "course"
    };
  },
  methods: {
    toggleSelect(e) {
      e.stopPropagation();
      const selector = document.querySelectorAll(".tier-wrapper");
      selector.forEach(item => {
        if (item.classList.contains("selected")) {
          item.classList.remove("selected");
        }
      });
      e.target.classList.add("selected");
      this.chosenPlan = e.target.id;
    },
    optionValidate() {
      this.showOption = true;
    },
    getPaymentOptions() {
      subscriptionApi
        .getPaymentMethods()
        .then(res => {
          this.paymentOptions = res.data;
          // this.selectedOption = res.data[0];
        })
        .catch(e => {
          console.error("getPaymentMethods api failed", e);
        });
    },
    setIsSubscribed() {
      if (this.isAuthenticated && !this.isCheckout) {
        if (this.getUserRole === "teacher") {
          this.$router.push({
            path: "course_description",
            query: {
              courseId: this.getSelectedCourse.course_id,
              courseType: this.getSelectedCourse.isLiveCourse
                ? "liveCourse"
                : "course"
            }
          });
          // if (this.getSelectedCourse.isLiveCourse) {
          //   if (this.getTeacherLiveCourses.length > 0) {
          //     if (
          //       this.getTeacherLiveCourses.some(
          //         courseD => courseD.course_id === this.getSelectedCourse.course_id
          //       )
          //     ) {
          //       this.$router.push({
          //         path: "course_description",
          //         query: {
          //           courseId: this.getSelectedCourse.course_id,
          //           courseType: this.getSelectedCourse.isLiveCourse? "liveCourse":"course"
          //         }
          //       });
          //     }
          //   }
          //   if (this.getSubscribedLiveCourses.length > 0) {
          //     if (
          //       this.getSubscribedLiveCourses.some(
          //         courseD => courseD.course_id === this.getSelectedCourse.course_id
          //       )
          //     ) {
          //       this.$router.push({
          //         path: "course_description",
          //         query: {
          //           courseId: this.getSelectedCourse.course_id,
          //             courseType: this.getSelectedCourse.isLiveCourse? "liveCourse":"course"
          //         }
          //       });
          //     }
          //   }
          // } else {
          //   if (this.getTeacherCourses.length > 0) {
          //     if (
          //       this.getTeacherCourses.some(
          //         courseD => courseD.course_id === this.getSelectedCourse.course_id
          //       )
          //     ) {
          //       this.$router.push({
          //         path: "course_description",
          //         query: {
          //           courseId: this.getSelectedCourse.course_id
          //         }
          //       });
          //     }
          //   }
          //   if (this.getSubscribedCourses.length > 0) {
          //     if (
          //       this.getSubscribedCourses.some(
          //         courseD =>courseD.course_id === this.getSelectedCourse.course_id
          //       )
          //     ) {
          //       this.$router.push({
          //         path: "course_description",
          //         query: {
          //           courseId: this.getSelectedCourse.course_id
          //         }
          //       });
          //     }
          //   }
          // }
        } else if (this.getUserRole === "student") {
          if (this.getSelectedCourse.isLiveCourse) {
            if (this.getSubscribedLiveCourses.length > 0) {
              if (
                this.getSubscribedLiveCourses.some(
                  courseD =>
                    courseD.course_id === this.getSelectedCourse.course_id
                )
              ) {
                this.$router.push({
                  path: "course_description",
                  query: {
                    courseId: this.getSelectedCourse.course_id,
                    courseType: this.getSelectedCourse.isLiveCourse
                      ? "liveCourse"
                      : "course"
                  }
                });
              }
            }
          } else {
            if (this.getSubscribedCourses.length > 0) {
              if (
                this.getSubscribedCourses.some(
                  courseD =>
                    courseD.course_id === this.getSelectedCourse.course_id
                )
              ) {
                this.$router.push({
                  path: "course_description",
                  query: {
                    courseId: this.getSelectedCourse.course_id
                  }
                });
              }
            }
          }
        }
      } else if (this.isAuthenticated && this.isCheckout) {
        if (this.getUserRole === "teacher") {
          this.getCart.forEach(cartData => {
            if (cartData.course_type === "course") {
              if (this.getTeacherCourses.length > 0) {
                if (
                  this.getTeacherCourses.some(
                    courseD => courseD.course_id === cartData.course_id
                  )
                ) {
                  this.redirectToCart();
                }
              }
              if (this.getSubscribedCourses.length > 0) {
                if (
                  this.getSubscribedCourses.some(
                    courseD => courseD.course_id === cartData.course_id
                  )
                ) {
                  this.redirectToCart();
                }
              }
            } else {
              if (this.getTeacherLiveCourses.length > 0) {
                if (
                  this.getTeacherLiveCourses.some(
                    courseD => courseD.course_id === cartData.course_id
                  )
                ) {
                  this.redirectToCart();
                }
              }
              if (this.getSubscribedLiveCourses.length > 0) {
                if (
                  this.getSubscribedLiveCourses.some(
                    courseD => courseD.course_id === cartData.course_id
                  )
                ) {
                  this.redirectToCart();
                }
              }
            }
          });
        } else if (this.getUserRole === "student") {
          this.getCart.forEach(cartData => {
            if (cartData.course_type === "course") {
              if (this.getSubscribedCourses.length > 0) {
                if (
                  this.getSubscribedCourses.some(
                    courseD => courseD.course_id === cartData.course_id
                  )
                ) {
                  this.redirectToCart();
                }
              }
            } else {
              if (this.getSubscribedLiveCourses.length > 0) {
                if (
                  this.getSubscribedLiveCourses.some(
                    courseD => courseD.course_id === cartData.course_id
                  )
                ) {
                  this.redirectToCart();
                }
              }
            }
          });
        }
      } else {
        this.isSubscribed = false;
      }
    },
    setCourseData() {
      if (this.isCheckout) {
        this.getCart.forEach(cartData => {
          const cart = {
            course_id: cartData.course_id,
            course_name: cartData.course_name,
            price: parseInt(cartData.price, 10),
            course_type: cartData.course_type
          };
          this.courses.push(cart);
        });
      } else {
        this.type = this.getSelectedCourse.isLiveCourse
          ? "liveCourse"
          : "course";
        const cart = {
          course_id: this.getSelectedCourse.course_id,
          course_name: this.getSelectedCourse.course_name,
          price: parseInt(this.getSelectedCourse.price, 10),
          course_type: this.type
        };
        this.courses.push(cart);
      }
    },
    redirectToCart() {
      store.dispatch("events/setShowCartToast", true);
      this.$router.push("/cart");
    }
  },
  mounted() {
    // this.$route.meta.title = `Subscribe to ${this.getSelectedCourse.name}`;
    this.getPaymentOptions();
    this.setCourseData();
  },
  beforeMount() {
    this.setIsSubscribed();
  },
  beforeDestroy() {
    store.dispatch("events/setIsCheckout", false);
  }
};
</script>

<style scoped></style>
